import { useTranslation } from "../hooks/useTranslation";
import { LogoEestiLoto } from "./LogoEestiLoto";
import ageRestriction from "../icons/ageRestriction.svg";

const Footer = () => {
  const { t, getLocalizedPath } = useTranslation();

  return (
    <footer
      className="footer"
      role="contentinfo"
      aria-labelledby="footer-heading"
    >
      <div className="footer-content">
        <h2 id="footer-heading" className="sr-only"></h2>

        <a
          href="https://www.eestiloto.ee/"
          className="footer-logo"
          aria-label="Tagasi kodulehele"
        >
          <LogoEestiLoto color="#000043" />
        </a>

         {t("lang") !== "ru" ? (
          <p className="footer-disclaimer">
            <img src={ageRestriction} />
            <span>
              <strong>TÄHELEPANU!</strong> Tegemist on hasartmängu reklaamiga.
              Hasartmäng pole sobiv viis rahaliste probleemide lahendamiseks.
              Tutvuge reeglitega ja käituge vastutustundlikult!{" "}
            </span>
          </p>
        ) : (
          <p className="footer-disclaimer">
            {" "}
            <img src={ageRestriction} />{" "}
            <span>
              <strong>Внимание!</strong> Вы имеете дело с рекламой азартной
              игры. Азартные игры не являются средством решения материальных
              проблем. Ознакомьтесь с правилами и поступайте ответственно!{" "}
            </span>
          </p>
        )}
      </div>
    </footer>
  );
};

export default Footer;
